import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-sinistro-sanitario-view',
  templateUrl: './form-sinistro-sanitario-view.component.html',
  styleUrls: ['./form-sinistro-sanitario-view.component.css']
})
export class FormSinistroSanitarioViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
